import React, { useState, useEffect } from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { getMessage } from 'util/locale';

// Components
import OverlaySelectLayerGroups from 'imagery/OverlaySelectLayerGroups';
import OverlaySelectLayers from 'imagery/OverlaySelectLayers';
import OverlaySelectLayerSeasons from 'imagery/OverlaySelectLayerSeasons';
import OverlaySelectLayerDates from 'imagery/OverlaySelectLayerDates';
import { Spinner } from '@tcc/crate';

const ZoneGenerationSelection = ({
  areCompleteMapLayersLoaded,
  areMapLayersLoaded,
  completeMapLayers,
  completeMapYear,
  fetchCompleteMapLayers,
  fetchZoneLayers,
  fieldId,
  getImagesForSeason,
  getSeasons,
  layerGroups,
  setMapLayer,
  selectedUuid,
  selectedLayer,
  showDates,
  showSeasons,
  requestCompleteMapsJob
}) => {
  const [selectedLayerGroup, setSelectedLayerGroup] = useState();
  const [selectedSeason, setSelectedSeason] = useState();

  useEffect(() => {
    fetchZoneLayers();
    fetchCompleteMapLayers();
  }, []);

  const showsSeasonsSelectedLayer = selectedLayer && showSeasons(selectedLayer);
  const showsDatesSelectedSeason = selectedLayer && selectedSeason && showDates(selectedLayer);
  
  const baseString = 'vra-zone-generation-layer-selection';

  const classString = classNames({
    [`${baseString}`]: true
  });

  const seperatorDivClass = classNames({
    [`${baseString}-seperator`]: true
  });

  const tableClassString = classNames({
    [ `${baseString}__table-initial`]: !showsSeasonsSelectedLayer,
    [ `${baseString}__table-layer-selected `]: showsSeasonsSelectedLayer
  });
  const layerGroupClassString = classNames({
    [ `${baseString}__layer-group-initial`]: !showsSeasonsSelectedLayer
  });
  const tableHeaderRowClassString = classNames({
    [ `${baseString}__table-header-row`]: true
  });


  const chooseLayer = (layer) => {
    let season = null;
    if(showSeasons(layer)) {
      const seasons = getSeasons(layer);
      season = seasons.length ? seasons[0] : null;
      // overwrite year if completeMapYear is set to fix bug going from next step to prev step
      season = completeMapYear ? completeMapYear : season;
      setSelectedSeason(season);
    }
    const mapLayer = {
      selectedMapType: layer,
      selectedMapUuid: null
    };
    setMapLayer(mapLayer);
  };

  const chooseSeason = (year) => {
    
    Promise.resolve().then(() => {
      return requestCompleteMapsJob(fieldId, year)
      .then(() => {
        return fetchCompleteMapLayers();
      });
    });

    setSelectedSeason(year);
  };

  const onSelectUuid = (uuid) => {
    const mapLayer = {
      selectedMapType: selectedLayer,
      selectedMapUuid: uuid
    };
    setMapLayer(mapLayer);
  };
  
  return (
    areMapLayersLoaded
      ? <section className={classString}>
        <div className={seperatorDivClass}>
          <table className={tableClassString}>
            <thead>
              <tr className={tableHeaderRowClassString}>
                <th>{getMessage('label-text__generate-zones-layer-select')}</th>
                <th/>
                <th className='vra-layer-selector-th--seasons'>{
                  showsSeasonsSelectedLayer && getMessage('label-text__season')
                }</th>
                <th>{showsDatesSelectedSeason && getMessage('label-text__image-date')}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className={layerGroupClassString}>
                  <OverlaySelectLayerGroups
                    extendedHeight={true}
                    groups={layerGroups}
                    onSelect={setSelectedLayerGroup}
                    selectedGroup={selectedLayerGroup}
                  />
                </td>
                <td>{
                  selectedLayerGroup
                    && <OverlaySelectLayers
                      extendedHeight={true}
                      layerGroup={selectedLayerGroup}
                      onSelect={chooseLayer}
                      selectedLayer={selectedLayer}
                    />
                }</td>
                <td>{
                  showsSeasonsSelectedLayer
                    && <OverlaySelectLayerSeasons
                      extendedHeight={true}
                      onSelect={chooseSeason}
                      seasons={getSeasons(selectedLayer)}
                      selectedSeason={selectedSeason}
                    />
                }</td>
                <td>{
                  showsDatesSelectedSeason
                      && <OverlaySelectLayerDates
                        areCompleteMapLayersLoaded={areCompleteMapLayersLoaded}
                        completeMapLayers={completeMapLayers}
                        datesAndImages={getImagesForSeason(selectedLayer, selectedSeason)}
                        extendedHeight={true}
                        isfilteredByCompleteMapLayers={true}
                        onSelect={onSelectUuid}
                        selectedUuid={selectedUuid}
                      />
                    
                }</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      : <Spinner className='vra-management-zones-container-spinner' size='24' />
  );
};

ZoneGenerationSelection.propTypes = {
  areCompleteMapLayersLoaded: propTypes.bool.isRequired,
  areMapLayersLoaded: propTypes.bool.isRequired,
  completeMapLayers: propTypes.object,
  completeMapYear: propTypes.string,
  fetchCompleteMapLayers: propTypes.func.isRequired,
  fetchZoneLayers: propTypes.func.isRequired,
  fieldId: propTypes.string.isRequired,
  getImagesForSeason: propTypes.func.isRequired,
  getSeasons: propTypes.func.isRequired,
  layerGroups: propTypes.array.isRequired,
  requestCompleteMapsJob: propTypes.func.isRequired,
  selectedLayer: propTypes.string,
  selectedUuid: propTypes.string,
  setMapLayer: propTypes.func,
  showDates: propTypes.func.isRequired,
  showSeasons: propTypes.func.isRequired
};

export default ZoneGenerationSelection;
